/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { relativePrioritySchema } from './relativePrioritySchema';
import { upsertEstimationRequestSchema } from './upsertEstimationRequestSchema';

export const createEstimationSchemeRequestSchema = z.object({
  description: z.string().nullish(),
  get estimations() {
    return z.array(upsertEstimationRequestSchema);
  },
  isOrganizationDefault: z.boolean(),
  name: z.string(),
  get relativePriority() {
    return z.union([relativePrioritySchema, z.null()]).optional();
  },
});
